/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_CtaInputs */

const en_not_found_cta = /** @type {(inputs: Not_Found_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to the start`)
};

const pl_not_found_cta = /** @type {(inputs: Not_Found_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wróć na stronę główną`)
};

/**
* | output |
* | --- |
* | "Back to the start" |
*
* @param {Not_Found_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const not_found_cta = /** @type {((inputs?: Not_Found_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_not_found_cta(inputs)
	return en_not_found_cta(inputs)
});